<template>
  <v-menu offset-y left nudge-bottom="8" content-class="user-menu-dropdown">
    <v-dialog v-model="contactusDialog" width="384">
      <Contactus />
    </v-dialog>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        :color="avatarColor"
        size="36"
        v-bind="attrs"
        v-on="on"
        aria-label="User Profile"
        class="app-bar-avatar ml-1"
      >
        <span class="app-bar-avatar__initials white--text">{{ userInitials }}</span>
      </v-avatar>
    </template>
    <v-list nav dense class="py-2">
      <v-list-item class="user-menu-header px-4" two-line>
        <v-list-item-avatar :color="avatarColor" size="40">
          <span class="white--text font-weight-bold">{{ userInitials }}</span>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">{{ userName }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{ tenantName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list-item class="px-4">
        <v-switch
          v-model="notification"
          :true-value="true"
          :false-value="false"
          inset
          hide-details
          dense
          class="mt-0"
          :label="notification ? 'แจ้งเตือน' : 'ไม่แจ้งเตือน'"
        />
      </v-list-item>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        class="px-2"
        @click="menuActionClick(item.action)"
      >
        <v-list-item-icon class="mr-3">
          <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'

const AVATAR_COLORS = [
  '#1976D2', '#388E3C', '#F57C00', '#7B1FA2',
  '#C2185B', '#0097A7', '#5D4037', '#455A64',
]

export default {
  computed: {
    ...mapState('User', ['user', 'tenant']),
    notification: {
      get() {
        return this.$store.state.User.notification
      },
      set(value) {
        this.$store.dispatch('User/SET_NOTIFICATION', value)
      }
    },
    userName() {
      return this.user?.name || this.user?.given_name || 'User'
    },
    tenantName() {
      return this.tenant?.TenantName || ''
    },
    userInitials() {
      const name = this.userName.trim()
      if (!name) return '?'
      const parts = name.split(/\s+/).filter(Boolean)
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      }
      return name.slice(0, 2).toUpperCase()
    },
    avatarColor() {
      const name = this.userName
      let hash = 0
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash)
      }
      return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
    },
  },
  data() {
    return {
      items: [
        { title: 'ออกจากระบบ', icon: 'mdi-logout', action: 'logout' }
      ],
      contactusDialog: false,
    }
  },
  methods: {
    menuActionClick(action) {
      switch (action) {
        case 'logout':
          this.$auth.logout()
          break
        case 'contactUs':
          this.contactusDialog = true
          break
      }
    }
  }
}
</script>

<style>
.app-bar-avatar {
  border: 2px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
}

.app-bar-avatar:hover {
  border-color: rgba(255, 255, 255, 0.85);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
  transform: scale(1.05);
}

.app-bar-avatar__initials {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
  user-select: none;
}

.user-menu-dropdown {
  border-radius: 12px !important;
  min-width: 240px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

.user-menu-header {
  pointer-events: none;
}
</style>
